//export const BASE_URL=process.env.NODE_ENV='development'?'':'',
// export const BASE_URL = "";
export const BASE_URL = "https://footorder-qa-server.onrender.com";
export const FOOD_ITEM_URL = "/api/foodItems";
export const CUSTOMERS_URL = "/api/customer";
export const OUTLET_URL = "/api/outlet";
export const ORDERS_URL = "/api/orders";
export const TABLE_URL = "/api/outletTables";
